// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__343od","productName":"Table_productName__h7dtc"};